import React from 'react';
import { connect } from 'react-redux';

import wrapMain from '../../wrap-main';

import Table from '../../../shared/new-table/main';
import table from './table-initial-data';

function CustomContentList({ rows }) {
	return (
		<Table table={table} rows={rows} />
	);
}

function mapStateToProps(state) {
	return {
		rows: state.root.lists['banner-custom-content-ids']
	};
}

export default connect(mapStateToProps)(wrapMain(CustomContentList));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/custom-content/list/main.js